import React, { useEffect, useRef, useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import rightArrow from '../../../Assets/navbar/right-arrow.svg';
import axios from 'axios';

import frontRight from '../../../Assets/crane/front-right.jpg'
import frontLeft from '../../../Assets/crane/front-left.jpg'
import rearLeft from '../../../Assets/crane/rear-left.jpg'
import rearRight from '../../../Assets/crane/rear-right.jpg'
import odometerIcon from '../../../Assets/crane/odometer-icon.jpg'
import { FiDownload } from 'react-icons/fi';
import imageCompression from 'browser-image-compression';


const vehicleSlots = [
  { key: 'frontRight', label: 'Front Right' },
  { key: 'frontLeft', label: 'Front Left' },
  { key: 'rearRight', label: 'Rear Right' },
  { key: 'rearLeft', label: 'Rear Left' },
];

const tyreSlots = [
  { key: 'tyreFrontRight', label: 'Tyre Front Right' },
  { key: 'tyreFrontLeft', label: 'Tyre Front Left' },
  { key: 'tyreRearRight', label: 'Tyre Rear Right' },
  { key: 'tyreRearLeft', label: 'Tyre Rear Left' },
  { key: 'odometer', label: 'Odometer' },
  { key: 'selfie', label: 'Selfie with Vehicle' },
  { key: 'stepney', label: 'Stepney' }, // ✅ Added
];

const toolTags = [
  "Jack",
  "Jack Rod",
  "Wheels Spanner",
  "Rope",
  "Tirpal",
  "Spanners",
  "Tyre Lever",
  "Belt",
];

const ImageUploader = ({
  title,
  slots,
  onContinue,
  onBack,
  showBack = false,
  initialImages = {},
  placeholders = {},
  isReadonly = false,
  accidentVehicleCode,
  vendorType,
}) => {

  const [images, setImages] = useState(initialImages || {});

  const [dynamicSlots, setDynamicSlots] = useState([]);


  useEffect(() => {
    if (!initialImages) return;

    setImages(initialImages);

    // Only restore additional slots if this is the Tyre Images section
    if (title === "Upload Tyre Images") {
      const dynamicKeys = Object.keys(initialImages).filter(key => key.startsWith('additional_'));

      const slotsToAdd = dynamicKeys.map((key, index) => ({
        key,
        label: `Additional ${index + 1}`
      }));

      setDynamicSlots(slotsToAdd);
    } else {
      // 🚫 Ensure no additional slots for vehicle images
      setDynamicSlots([]);
    }
  }, [initialImages, title]);




  const requiredKeys = slots.map(s => s.key);
  const isContinueEnabled = isReadonly || requiredKeys.every(key => !!images[key]);


  const handleImageChange = (key, file) => {

    uploadImage(key, file)

    // setImages(prev => ({ ...prev, [key]: file }));
  };

  const removeImage = (key) => {
    setImages(prev => {
      const newImages = { ...prev };
      delete newImages[key];
      return newImages;
    });
  };

  const handleAddNewSlot = () => {
    const count = dynamicSlots.length + 1;
    const newKey = `additional_${Date.now()}`;
    const newSlot = { key: newKey, label: `Additional ${count}` };
    setDynamicSlots(prev => [...prev, newSlot]);

    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      } 
    }, 100);

  };

  const scrollRef = useRef(null);
  const handleDownload = (url) => {
    try {
      const s3Key = new URL(url).pathname.substring(1);
      const downloadUrl = `${process.env.REACT_APP_BACKEND_URL}/api/downloadVehicleImage?key=${encodeURIComponent(s3Key)}`;

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = ''; // Optional: you can pass a filename if desired
      link.target = '_blank'; // Optional: opens in new tab if not downloaded
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      alert("Download failed.");
      console.error(err);
    }
  };


  const [isLoading, setIsLoading] = useState(false);

  const compressImage = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");

          const scale = Math.min(800 / img.width, 800 / img.height, 1); // scale down if larger than 800px
          canvas.width = img.width * scale;
          canvas.height = img.height * scale;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          canvas.toBlob(
            (blob) => {
              if (blob) {
                const compressedFile = new File([blob], file.name, { type: file.type });
                resolve(compressedFile);
              } else {
                reject(new Error("Compression failed"));
              }
            },
            file.type,
            0.7 // quality: 0.0 to 1.0
          );
        };
        img.onerror = reject;
        img.src = event.target.result;
      };

      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const uploadImage = async (key, file) => {
    if (!file) return;

    try {

      const compressedFile = await compressImage(file);

      // 👇 Create a unique filename
      const uniqueFile = new File(
        [compressedFile],
        `${key}_${Date.now()}.${file.type.split('/')[1] || 'jpg'}`,
        { type: file.type }
      );

      const formData = new FormData();
      const block = key.startsWith('front') || key.startsWith('rear') ? 'photos1' : 'photos2';
      formData.append(`${block}[${key}]`, uniqueFile);

      const userId = localStorage.getItem("userId");
      setIsLoading(true);

      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/uploadVehicleImagesByDriver/${userId}/${accidentVehicleCode}/${vendorType}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (res.status === 200) {
        setImages((prev) => ({ ...prev, [key]: res.data.data.key }));
      }

    } catch (error) {
      console.error("Image upload failed:", error);
      alert("Image upload failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };



  return (
    <div className="mb-12 bg-white md:p-[78px] max-w-[1148px] mx-auto p-5 pt-[10%] rounded-[30px]">
      <div className="font-satoshi">
        <div className="flex gap-3 items-center mb-4">
          <img
            src="https://cdn.pixabay.com/photo/2016/01/03/00/43/upload-1118929_640.png"
            className="h-[40px] w-[40px] mt-3"
            alt=""
          />
          <h2 className="text-lg font-semibold mt-[6%]">{title}</h2>
        </div>

        {isLoading && (
          <div className="fixed inset-0 z-[9999] bg-gray-100 bg-opacity-80 flex items-center justify-center">
            <div className="loader2 h-[50px] w-[20px]"></div>
          </div>
        )}

        <div className={` overflow-x-hidden ${title === "Upload Vehicle Images" ? "h-[60vh] overflow-y-hidden" : ""
          }`} ref={scrollRef} >
          {/* Scrollable slot area */}
          <div className="flex items-center justify-center h-full">
            <div className="grid grid-cols-2 gap-6 place-items-center mx-[3%] px-[1%]">


              {[...slots, ...dynamicSlots].map(({ key, label }) => {
                const file = images[key];
                let imageSrc = null;

                if (file instanceof File) {
                  imageSrc = URL.createObjectURL(file);
                } else if (typeof file === "string" && file.startsWith("http")) {
                  imageSrc = file;
                } else {
                  imageSrc = placeholders?.[key] || null;
                }

                return (
                  <div
                    key={key}
                    className="relative rounded-xl border-2 border-dotted border-gray-400 h-[140px] w-[140px]"
                  >
                    <div className="relative w-full h-full rounded-xl overflow-hidden">
                      {imageSrc && (
                        <img
                          src={imageSrc}
                          alt={key}
                          className="w-full h-full object-contain"
                        />
                      )}



                      {file && (
                        isReadonly ? (
                          <button
                            type="button"
                            onClick={() =>
                              handleDownload(typeof file === 'string' ? file : URL.createObjectURL(file))
                            }
                            className="absolute top-1 right-1 bg-blue-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-blue-700 z-20"
                            title="Download Image"
                          >
                            ⬇️
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={() => removeImage(key)}
                            className="absolute top-1 right-1 bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-700 z-0"
                            title="Remove Image"
                          >
                            ❌
                          </button>
                        )
                      )}



                      <button
                        type="button"
                        onClick={() => {
                          if (isReadonly) return;
                          const input = document.getElementById(`fileInput-${key}`);
                          if (input) input.click();
                        }}
                        className={`absolute inset-0 flex items-center justify-center z-10 ${file || isReadonly ? "pointer-events-none" : ""
                          }`}
                      >
                        {!file && !isReadonly && (
                          <div className="bg-gray-700 p-2 rounded-full text-white shadow-lg hover:bg-black">
                            <FaPlus />
                          </div>
                        )}
                      </button>

                      {!isReadonly && (
                        <input
                          type="file"
                          id={`fileInput-${key}`}
                          accept="image/*"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) handleImageChange(key, file);
                            e.target.value = null;
                          }}
                          style={{ display: "none" }}
                        />
                      )}
                    </div>

                    <label className="absolute bottom-1 left-0 right-0 text-center text-xs font-semibold text-white bg-black bg-opacity-50 rounded-md mx-2 py-0.5">
                      {label}
                    </label>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Button container outside scrollable slots */}
          <div className="flex justify-end mt-4 ">
            {/* <button
              onClick={handleAddNewSlot}
              className="z-10 bg-[#21A6E9] hover:bg-[#1e94d6] text-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2"
            >
              <FaPlus />
              Add New
            </button> */}

            {title === "Upload Tyre Images" && !isReadonly && (
              <button
                onClick={handleAddNewSlot}
                className="z-10 bg-[#21A6E9] hover:bg-[#1e94d6] text-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2"
              >
                <FaPlus />
                Add New
              </button>
            )}


          </div>


        </div>





        <div hidden className="flex justify-center fixed bottom-0 left-0 right-0 z-10 md:relative mt-6 z-50">
          <div className="flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-2 mx-auto md:rounded-none md:p-0">
            {showBack && (
              <button
                onClick={() => onBack(images)}
                className="flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full w-full bg-[#EE3840] hover:bg-[#d32f2f]"
              >
                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px] rotate-180" />
                Back
              </button>
            )}
            <button
              disabled={!isContinueEnabled}
              onClick={() => onContinue(images)}
              className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full w-full ${isContinueEnabled ? 'bg-[#21A6E9] hover:bg-[#1e94d6]' : 'bg-[#a7dbf5] cursor-not-allowed'}`}
            >
              Continue
              <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px]" />
            </button>
          </div>
        </div>

        <div className="flex justify-center fixed bottom-0 left-0 right-0 z-50">
          <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full  gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">

            {showBack && (
              <button
                onClick={() => {
                  if (scrollRef.current) scrollRef.current.scrollTop = 0;
                  onBack(images);
                }}
                className="flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full w-full bg-[#EE3840] hover:bg-[#d32f2f]"
              >
                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px] rotate-180" />
                Back
              </button>
            )}

            <button
              disabled={!isContinueEnabled}
              onClick={() => {
                if (scrollRef.current) scrollRef.current.scrollTop = 0;
                onContinue(images);
              }}
              className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full w-full ${isContinueEnabled ? 'bg-[#21A6E9] hover:bg-[#1e94d6]' : 'bg-[#a7dbf5] cursor-not-allowed'}`}
            >
              Continue
              <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px]" />
            </button>


          </div>
        </div>

      </div>
    </div>
  );
};

const ToolSelector = ({
  onBack,
  onContinue,
  initialTools = {},
  initialFuel = 0,
  initialSummary = '',
  isReadonly = false,
  isLoading,
  loadingAccept,
  loadingReject,
  deselectedTools = [],

}) => {
  useEffect(() => {
    const scrollToTop = () => {
      // Try multiple scroll methods
      window.scrollTo({ top: 0, behavior: 'instant' });
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // Also try scrolling the modal container if it exists
      const modalContainer = document.querySelector('.fixed.inset-0.bg-white');
      if (modalContainer) {
        modalContainer.scrollTop = 0;
      }
    };

    // Immediate scroll
    scrollToTop();

    // Backup scrolls with delays
    const timeout1 = setTimeout(scrollToTop, 50);
    const timeout2 = setTimeout(scrollToTop, 100);
    const timeout3 = setTimeout(scrollToTop, 200);
    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
      clearTimeout(timeout3);
    };
  }, []); 

  const [toolSelections, setToolSelections] = useState(() => {
    const defaultState = toolTags.reduce((acc, tag) => {
      if (Array.isArray(initialTools)) {
        acc[tag] = initialTools.includes(tag) ? 'yes' : 'no';
      } else {
        acc[tag] = null;
      }
      return acc;
    }, {});
    return defaultState;
  });

  useEffect(() => {

    console.log('initialTools ======================== ')
    console.log(initialTools)

    if (Array.isArray(initialTools)) {
      const updatedState = toolTags.reduce((acc, tag) => {
        acc[tag] = initialTools.includes(tag) ? 'yes' : 'no';
        return acc;
      }, {});

      console.log('toolTags ======================== ')
      console.log(toolTags)

      console.log('updatedState ======================== ')
      console.log(updatedState)


      setToolSelections(updatedState);
    }
  }, [initialTools, deselectedTools]);

  useEffect(() => {
    setFuelQty(initialFuel);
  }, [initialFuel]);

  useEffect(() => {
    setToolSummary(initialSummary);
  }, [initialSummary]);



  const [fuelQty, setFuelQty] = useState(initialFuel);
  const [toolSummary, setToolSummary] = useState(initialSummary);

  const handleSelect = (tool, value) => {
    setToolSelections(prev => ({ ...prev, [tool]: value }));
  };

  // const isContinueEnabled =
  // fuelQty.trim() !== '' && parseFloat(fuelQty) > 0;
  const isContinueEnabled = isReadonly || true

  // (
  //   fuelQty.trim() !== '' &&
  //   parseFloat(fuelQty) > 0 &&
  //   Object.values(toolSelections).some(v => v === 'yes')
  // );


  return (
    <div className="mb-12 bg-white md:p-[78px] max-w-[1148px] mx-auto p-5 pt-[10%] rounded-[30px] font-satoshi">
      <h2 className="text-lg font-semibold mb-6 text-center mt-[6%]">Select below Accessories</h2>



      <div className="flex flex-col gap-4">
        {(

          isReadonly
            ? Object.entries(toolSelections).map(([name, status]) => ({
              name,
              status
            }))
            : toolTags.map((tool) => ({
              name: tool,
              status: toolSelections[tool]
            }))
        ).map(({ name, status }) => (
          <div
            key={name}
            className={`flex items-center justify-between p-3 rounded-md shadow-sm transition-all ${status === 'yes'
              ? 'bjg-green-100 border border-green-600'
              : status === 'no'
                ? ' border border-red-600'
                : 'border border-gray-300'
              }`}
          >
            <span className="text-sm font-medium w-1/3">{name}</span>

            {isReadonly ? (
              <div className="flex gap-3 text-xl">
                {status === 'yes' && (
                  // <span className="text-green-600 font-bold">✓</span>

                  <button
                    className={`text-green-600 font-bold text-xl w-8 h-8 rounded-full flex items-center justify-center border ${toolSelections[name] === 'yes'
                      ? 'bg-green-600 text-white border-green-600'
                      : 'border-gray-300'
                      }`}
                  // onClick={() => handleSelect(name, 'yes')}
                  >
                    ✓
                  </button>

                )}
                {status === 'no' && (
                  // <span className="text-red-600 font-bold">✕</span>

                  <button
                    className={`text-red-600 font-bold text-xl w-8 h-8 rounded-full flex items-center justify-center border ${toolSelections[name] === 'no'
                      ? 'bg-red-600 text-white border-red-600'
                      : 'border-gray-300'
                      }`}
                  // onClick={() => handleSelect(name, 'no')}
                  >
                    ✕
                  </button>

                )}
              </div>
            ) : (
              <div className="flex gap-3">
                <button
                  className={`text-green-600 font-bold text-xl w-8 h-8 rounded-full flex items-center justify-center border ${toolSelections[name] === 'yes'
                    ? 'bg-green-600 text-white border-green-600'
                    : 'border-gray-300'
                    }`}
                  onClick={() => handleSelect(name, 'yes')}
                >
                  ✓
                </button>
                <button
                  className={`text-red-600 font-bold text-xl w-8 h-8 rounded-full flex items-center justify-center border ${toolSelections[name] === 'no'
                    ? 'bg-red-600 text-white border-red-600'
                    : 'border-gray-300'
                    }`}
                  onClick={() => handleSelect(name, 'no')}
                >
                  ✕
                </button>
              </div>
            )}
          </div>
        ))}
      </div>


      <div className="flex gap-4 mt-6 items-center">
        <label className="text-sm font-medium">Fuel in Tank (Liters)</label>

        <input
          type="number"
          inputMode="numeric"
          pattern="[0-9]*"
          max="999"
          placeholder="0"
          value={fuelQty}
          onChange={(e) => {
          const value = e.target.value; 
          if (value.length <=3) {
          setFuelQty(value)
          }
        }}
          readOnly={isReadonly}
          className="w-1/2 px-3 py-2 border border-black rounded-md text-black"
        />

      </div>

      <div className="mt-4" style={{ textAlign: "left" }}>
        <label className="text-sm font-medium text-gray-600 mb-1">Tools Summary  (if any)</label>
        <textarea
          className={`w-full border border-gray-300 rounded-md p-2 text-sm ${isReadonly ? 'mb-[15px]' : 'mb-[10px]'}`}
          value={toolSummary}
          onChange={(e) => setToolSummary(e.target.value)}
          rows={4}
          placeholder="Enter additional tools if any..."
          readOnly={isReadonly}
        />

      </div>

      <div className="flex justify-center fixed bottom-0 left-0 right-0 z-10 md:relative mt-6 bg-white">

        {!isReadonly && (

          <div className="flex justify-center fixed bottom-0 left-0 right-0 z-50">
            <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full  gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">

              <button
                onClick={() => onBack(toolSelections, fuelQty, toolSummary)}
                className="flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full w-full bg-[#EE3840] hover:bg-[#d32f2f]"
              >
                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px] rotate-180" />
                Back
              </button>
              <button
                disabled={!isContinueEnabled}
                // onClick={() => {
                //   const selectedToolNames = Object.entries(toolSelections)
                //     .filter(([_, value]) => value === 'yes')
                //     .map(([key]) => key);

                //   onContinue(toolSelections, selectedToolNames, fuelQty, toolSummary);

                // }}

                onClick={async () => {
                  // setLoadingAccept(true); // ✅ Start Accept loading
                  try {
                    console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^')
                    console.log(toolSelections)

                    const selectedToolNames = Object.entries(toolSelections)
                      .filter(([_, value]) => value === 'yes')
                      .map(([key]) => key);

                    console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^')
                    console.log(toolSelections, selectedToolNames, fuelQty, toolSummary)
                    await onContinue(toolSelections, selectedToolNames, fuelQty, toolSummary);
                  } catch (error) {
                    console.error("Accept API failed", error);
                    alert("Something went wrong. Please try again.");
                  } finally {
                    // setLoadingAccept(false); // ✅ End Accept loading
                  }
                }}

                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full w-full ${isContinueEnabled ? 'bg-[#21A6E9] hover:bg-[#1e94d6]' : 'bg-[#a7dbf5] cursor-not-allowed'
                  }`}
              >
                {isLoading && (
                  <span
                    class="spinner-border spinner-border-sm me-1"></span>
                )}

                Finish
                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Finish" className="h-[24px] w-[24px]" />
              </button>


            </div>
          </div>

        )}

        {isReadonly && (

          <div className="flex justify-center fixed bottom-0 left-0 right-0 z-50">
            <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full  gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">

              <button
                onClick={() => onBack(toolSelections, fuelQty, toolSummary)}
                className="flex items-center justify-center gap-2 text-base font-medium py-3 px-2 rounded-full w-full bg-gray-500 text-white hover:bg-gray-600"
              >
                Back
              </button>

              <button
                className="flex items-center justify-center gap-2 text-base font-medium py-3 px-2 rounded-full w-full 
             bg-red-600 text-white hover:bg-red-700"
                // onClick={() => {
                //   const selectedToolNames = Object.entries(toolSelections)
                //     .filter(([_, value]) => value === 'yes')
                //     .map(([key]) => key);

                //   localStorage.setItem('action', 'true');
                //   onContinue(toolSelections, selectedToolNames, fuelQty, toolSummary);
                // }}

                onClick={async () => {
                  // setLoadingReject(true); // ✅ Start Reject loading
                  try {
                    const selectedToolNames = Object.entries(toolSelections)
                      .filter(([_, value]) => value === 'yes')
                      .map(([key]) => key);

                    localStorage.setItem('action', 'false');

                    await onContinue(toolSelections, selectedToolNames, fuelQty, toolSummary);
                  } catch (error) {
                    console.error("Reject API failed", error);
                    alert("Something went wrong. Please try again.");
                  } finally {
                    // setLoadingReject(false); // ✅ End Reject loading
                  }
                }}


              >

                {loadingReject && (
                  <span className="spinner-border spinner-border-sm me-1"></span>
                )}
                Reject
              </button>



              <button
                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full w-full ${isContinueEnabled ? 'bg-[#21A6E9] hover:bg-[#1e94d6]' : 'bg-[#a7dbf5] cursor-not-allowed'
                  }`}


                onClick={async () => {
                  // setLoadingAccept(true); // ✅ Start Accept loading
                  try {
                    const selectedToolNames = Object.entries(toolSelections)
                      .filter(([_, value]) => value === 'yes')
                      .map(([key]) => key);

                    localStorage.setItem('action', 'true');

                    await onContinue(toolSelections, selectedToolNames, fuelQty, toolSummary);
                  } catch (error) {
                    console.error("Accept API failed", error);
                    alert("Something went wrong. Please try again.");
                  } finally {
                    // setLoadingAccept(false); // ✅ End Accept loading
                  }
                }}


              >
                {loadingAccept && (
                  <span className="spinner-border spinner-border-sm me-1"></span>
                )}
                Accept

              </button>


            </div>
          </div>


        )}

      </div>
    </div>
  );
};

const VehicleInspectionFlow = ({ onFirstStepBack, accidentVehicleCode, vendorType }) => {
  const [step, setStep] = useState(1);
  const [vehicleImages, setVehicleImages] = useState({});
  const [tyreImages, setTyreImages] = useState({});
  const [tools, setTools] = useState([]);
  const [fuelQuantity, setFuelQuantity] = useState('');
  const [toolSummary, setToolSummary] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [loadingAccept, setLoadingAccept] = useState(false);
  const [loadingReject, setLoadingReject] = useState(false);


  const userId = localStorage.getItem("userId");

  const token = localStorage.getItem('token') || '';
  const currentService = localStorage.getItem("currentService")

  const vehiclePlaceholders = {
    frontRight,
    frontLeft,
    rearRight,
    rearLeft,
  };

  const tyrePlaceholders = {
    odometer: odometerIcon,
  };

  const isReadonly =
    userId?.startsWith("CC-") ||
      userId?.startsWith("CUD-")
      ? true
      : userId?.startsWith("VED-")
        ? false
        : false;

  // const isReadonly = true
  // const isReadonly = false

  const [deselectedTools, setDeselectedTools] = useState([]);

  const mockFetchReadonlyData = async (accidentVehicleCode) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/toolInfomation/${accidentVehicleCode}`
      );
      const data = response.data.data[0];
      console.log("Fetched from API:", data);
      // return     

      console.log('/////////////////////////////////////////////')
      console.log({
        vehicleImage: data.vehicleImage,
        tyresImage: data.tyresImage,
        tools: JSON.parse(data.selectedTools), //["Jack", "Jack Rod"], 
        toolSummary: data.toolingInfo,
        deselectedTools: JSON.parse(data.deselectedTools || '[]'),
        fuelQuantity: data.fuelQuantity,
      })

      // if (data?.length > 0) {
      return {
        vehicleImage: data.vehicleImage,
        tyresImage: data.tyresImage,
        tools: JSON.parse(data.selectedTools), //["Jack", "Jack Rod"], 
        toolSummary: data.toolingInfo,
        deselectedTools: JSON.parse(data.deselectedTools || '[]'),
        fuelQuantity: data.fuelQuantity,
      };
      // }
    } catch (error) {
      console.error("Error fetching data:", error);
    }

    return {
      vehicleImage: null,
      tyresImage: null,
      tools: ["Jack", "Jack Rod"],
      fuelQuantity: "197",
      toolSummary: "4545545"
    };
  };

  useEffect(() => {
    if (!accidentVehicleCode) return;

    (async () => {
      const data = await mockFetchReadonlyData(accidentVehicleCode);

      if (!data) return;

      // Always apply data in readonly mode
      if (isReadonly) {
        setVehicleImages(data.vehicleImage || {});
        setTyreImages(data.tyresImage || {});
        setTools(data.tools || []);
        setFuelQuantity(data.fuelQuantity || '');
        setToolSummary(data.toolSummary || '');
        setDeselectedTools(data.deselectedTools || []);
      } else {
        // In editable mode, apply only if data is available and meaningful
        if (data.vehicleImage) setVehicleImages(data.vehicleImage);
        if (data.tyresImage) setTyreImages(data.tyresImage);
        if (Array.isArray(data.tools) && data.tools.length > 0) setTools(data.tools);
        if (data.fuelQuantity) setFuelQuantity(data.fuelQuantity);
        if (data.toolSummary) setToolSummary(data.toolSummary);
      }
    })();
  }, [isReadonly, accidentVehicleCode]);



  const confirmationOnTools = async (action,) => {
    try {
      const response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/customerConfirmationOnTools/${userId}/${accidentVehicleCode}/${action}/${userId}/${vendorType}`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.data.status) {
        console.log("updated successfully");
        // alert('✅ successful!');
        onFirstStepBack();
        // alert(response.data.status)
      }
    } catch (error) {
      console.log("the error occurred", error.message);
    } finally {

    }
  };

  const handleSubmit = async ({ toolSelections, selectedTools, qty, summary }) => {
    console.log('*****************************************')
    console.log({ toolSelections, selectedTools, qty, summary })

    // alert('submitting...')
    // return

    if (isReadonly) {
      let action = localStorage.getItem('action')

      if (action === 'true') {
        setLoadingAccept(true)
      }
      if (action === 'false') {
        setLoadingReject(true)
      }

      await confirmationOnTools(action)
      setLoadingAccept(false)
      setLoadingReject(false)
      return
    }

    // return
    setIsLoading(true)

    // alert('done')
    // return

    const formData = new FormData();

    // Append vehicle images
    // Object.entries(vehicleImages).forEach(([key, file]) => {
    //   formData.append(`photos1[${key}]`, file);
    // });

    // // Append tyre images
    // Object.entries(tyreImages).forEach(([key, file]) => {
    //   formData.append(`photos2[${key}]`, file);
    // });

    // Append selected tools
    formData.append('tools', JSON.stringify(selectedTools));

    // Append fuel quantity
    formData.append('fuelQuantity', qty);

    // Append tool summary
    // formData.append('toolSummary', summary);
    formData.append('toolingInfo', summary);

    // console.log("✅ Selected Tools (yes):", selectedTools);
    // const deselectedTools = Object.entries(toolSelections)
    //   .filter(([_, value]) => value === 'no')
    //   .map(([key]) => key);


    // formData.append('deselectedTools', JSON.stringify(deselectedTools));
    // formData.append('toolStates', JSON.stringify(toolSelections));

    console.log(toolSelections, selectedTools, qty, summary)

    console.log('===========================')

    console.log('📦 FormData Contents:');
    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(`${key}: [File] name="${value.name}", size=${value.size}`);
      } else {
        console.log(`${key}:`, value);
      }
    }

    try {
      const response = await axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/vendor-on-accidentvehicle-tools/${userId}/${accidentVehicleCode}/${vendorType}`,
        data: formData,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      // alert('✅ Upload successful!');

      console.log('====================================== ............')
      console.log(response)

      if (response.data.status) {
        onFirstStepBack();
      }

    } catch (err) {
      console.error('Upload failed:', err);
      alert('❌ Something went wrong!');
    } finally {
      setIsLoading(false);
      setLoadingAccept(false)
      setLoadingReject(false)
    }
  };



  return (
    <>
      {(isLoading || loadingAccept || loadingReject) && (
        <div className="fixed inset-0 z-[9999] bg-gray-100 bg-opacity-80 flex items-center justify-center">
          <div className="loader2 h-[50px] w-[20px]"></div>
        </div>
      )}

      {step === 1 && (
        <ImageUploader
          title={isReadonly ? "View Vehicle Images" : "Upload Vehicle Images"}
          slots={vehicleSlots}
          onContinue={(data) => {
            setVehicleImages(data);
            setStep(2);
          }}
          initialImages={vehicleImages}
          showBack={true}
          isReadonly={isReadonly}
          accidentVehicleCode={accidentVehicleCode}
          vendorType={vendorType}
          onBack={onFirstStepBack}
          placeholders={vehiclePlaceholders}
        />
      )}

      {step === 2 && (
        <ImageUploader
          title={isReadonly ? "View Tyre Images" : "Upload Tyre Images"}
          slots={tyreSlots}
          onContinue={(data) => {
            setTyreImages(data);
            setStep(3);
          }}
          initialImages={tyreImages}
          showBack={true}
          isReadonly={isReadonly}
          accidentVehicleCode={accidentVehicleCode}
          vendorType={vendorType}
          onBack={(data) => {
            setTyreImages(data);
            setStep(1);
          }}
          placeholders={tyrePlaceholders}
        />
      )}

      {step === 3 && (
        <ToolSelector
          initialTools={tools}
          initialFuel={fuelQuantity}
          initialSummary={toolSummary}
          deselectedTools={deselectedTools}
          isReadonly={isReadonly}
          isLoading={isLoading}
          loadingAccept={loadingAccept}
          loadingReject={loadingReject}
          onBack={(toolSelections, fuel, summary) => {
            setTools(Object.entries(toolSelections).filter(([_, v]) => v === 'yes').map(([k]) => k));
            setDeselectedTools(Object.entries(toolSelections).filter(([_, v]) => v === 'no').map(([k]) => k));
            setFuelQuantity(fuel);
            setToolSummary(summary);
            setStep(2);
          }}
          onContinue={async (toolSelections, selectedToolNames, fuel, summary) => {
            setTools(selectedToolNames);
            setDeselectedTools(Object.entries(toolSelections).filter(([_, v]) => v === 'no').map(([k]) => k));
            setFuelQuantity(fuel);
            setToolSummary(summary);

            console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$');
            console.log(toolSelections, selectedToolNames, fuel, summary);

            await handleSubmit({
              toolSelections,
              selectedTools: selectedToolNames,
              qty: fuel,
              summary,
            });
          }}

        />
      )}

    </>
  );
};

const ShowVehicleInspectionFlow = ({ accidentVehicleCode, vendorType, }) => {
  const [openVehicleInspectionFlow, setOpenVehicleInspectionFlow] = useState(false);

  useEffect(() => {
    if (openVehicleInspectionFlow) {
      // Scroll the main window
      window.scrollTo({ top: 0, behavior: 'instant' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    } else {
      // Re-enable body scroll when modal closes
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [openVehicleInspectionFlow]);

  return (
    <>
      {/* BACKDROP + FULL WHITE SCREEN MODAL */}
      {openVehicleInspectionFlow && (
        <div className="fixed inset-0 bg-white z-50 overflow-auto mt-[-10%]">

          <VehicleInspectionFlow
            accidentVehicleCode={accidentVehicleCode}
            vendorType={vendorType}
            onFirstStepBack={() => {
              setOpenVehicleInspectionFlow(false);
            }}
          />
        </div>
      )}

      {/* ADD DETAILS BUTTON (HIDDEN WHEN MODAL OPEN) */}
      {!openVehicleInspectionFlow && (

        <div
          className={`font-satoshi text-[11px] mt-1 bg-blue-200 px-2 py-1 border border-blue-500 text-center rounded-full font-bold text-black flex items-center justify-center relative cursor-pointer  ${localStorage.getItem('userId')?.startsWith("CC-") ? "w-full" : "w-[50vw] leading-[0.25rem]"
            }`}
          onClick={() => setOpenVehicleInspectionFlow(true)}
        >
          <button className='h-[2rem]'>Vehicle Inspection</button>
        </div>

      )}

    </>
  );
};

export default ShowVehicleInspectionFlow;
